import { Map } from 'immutable'

export type TargetStatus = 'running' | 'paused'
export type TargetStatusUpdates = Map<TargetStatus, Map<string, string>>
type TargetStatusPayload = { id: string; status: TargetStatus; name: string }

export const changeTargetStatus =
  (toAddKey: TargetStatus, toRemoveKey: TargetStatus) => (updates: TargetStatusUpdates, payload: TargetStatusPayload) =>
    Map<TargetStatus, Map<string, string> | undefined>({
      [toAddKey]:
        payload.status.toLowerCase() === toAddKey
          ? updates.get(toAddKey)
          : updates.get(toAddKey)!.set(payload.id, payload.name),
      [toRemoveKey]: updates.get(toRemoveKey)!.delete(payload.id),
    })

export const getTargetsUpdatePayload = (updates: TargetStatusUpdates) => ({
  paused: updates.get('paused')!.keySeq().toArray(),
  running: updates.get('running')!.keySeq().toArray(),
})
